var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJoystick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#20AAB0"
    },
    points: "107.581,253.717 107.581,354.992 256.002,377.497 404.422,354.992 404.422,253.717  256.002,231.211 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.578,
    y: 354.99,
    style: {
      fill: "#086063"
    },
    width: 296.836,
    height: 157.01
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EA4820"
    },
    points: "381.917,0 130.087,0 124.266,65.623 256.002,88.128 387.738,65.623 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#14858A"
    },
    points: "404.422,253.717 387.738,65.623 124.266,65.623 107.581,253.717 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.105,
    y: 388.749,
    style: {
      fill: "#06484A"
    },
    width: 71.787,
    height: 123.251
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EA4820"
    },
    cx: 222.243,
    cy: 304.353,
    r: 16.879
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D92622"
    },
    cx: 289.76,
    cy: 304.353,
    r: 16.879
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#06484A"
    },
    d: "M359.411,329.673h-11.253c-4.662,0-8.44-3.779-8.44-8.44s3.778-8.44,8.44-8.44h11.253 c4.662,0,8.44,3.779,8.44,8.44S364.073,329.673,359.411,329.673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#06484A"
    },
    d: "M359.411,295.915h-11.253c-4.662,0-8.44-3.779-8.44-8.44c0-4.661,3.778-8.44,8.44-8.44h11.253 c4.662,0,8.44,3.779,8.44,8.44C367.851,292.136,364.073,295.915,359.411,295.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#06484A"
    },
    d: "M163.845,329.673h-11.253c-4.662,0-8.44-3.779-8.44-8.44s3.778-8.44,8.44-8.44h11.253 c4.662,0,8.44,3.779,8.44,8.44S168.506,329.673,163.845,329.673z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#06484A"
    },
    points: "356.841,99.381 155.162,99.381 144.467,219.959 367.537,219.959  "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoystick);
export default __webpack_public_path__ + "static/media/joystick.ba8c5959afd3ade22185b7155756e3e1.svg";
export { ForwardRef as ReactComponent };